import * as type from '../constants/ActionTypes';
import * as it from '../enums/itemsEnum';

export default function items(
  state = {
    isFetching: false,
  },
  action
) {
  switch (action.type) {
    case type.ITEM_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case type.ITEM_LIST_SUCCESS:

      let genericUrls = [];
      let genericBanners = [];
      let urlsByProduct = [];
      let bannersByProduct = [];

      //sort items into 4 groups according to type and if generic
      if(action.response){

        action.response.forEach( item => {
          if(item.generic === true){
            if(item.itemType === it.itemType.CUSTOMURL)
              genericUrls.push(item);

            if(item.itemType === it.itemType.BANNER)
              genericBanners.push(item);
          } else {

            if(item.itemType === it.itemType.CUSTOMURL)
              urlsByProduct.push(item);

            if(item.itemType === it.itemType.BANNER)
              bannersByProduct.push(item);

          }
        })
      }

      return Object.assign({}, state, {
        isFetching: false,
        genericUrls: genericUrls,
        genericBanners: genericBanners,
        urlsByProduct: urlsByProduct,
        bannersByProduct: bannersByProduct
      });
    case type.ITEM_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}